<template>
  <div class="device-content">
    <el-form label-postion="left">
      <el-form-item label="设备名称">
        <span>{{ name }}</span>
      </el-form-item>
      <el-form-item label="当前策略">
        <span>{{ stg_name }}</span>
      </el-form-item>
      <el-form-item label="修改策略">
        <el-select v-model="stg_id" placeholder="请选择">
          <el-option
            v-for="item in strategyOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="控制模式">
        <el-switch
          v-model="ms"
          active-text="自动"
          inactive-text="手动"
          :active-value="0"
          :inactive-value="1"
          inactive-color="gray"
          @change="controlCheck"
        ></el-switch>
      </el-form-item>
      <el-form-item :label="is_double?'灯1亮度':'路灯亮度'" v-if="ms" class="control-slider">
        <el-slider
          v-model="light"
          :min="0"
          :max="100"
          show-input
          @change="manualChange = true"
        ></el-slider>
      </el-form-item>
      <el-form-item label="灯2亮度" v-if="ms&&is_double" class="control-slider">
        <el-slider
          v-model="light2"
          :min="0"
          :max="100"
          show-input
          @change="manualChange = true"
        ></el-slider>
      </el-form-item>
      <el-form-item v-if="dev_ctrl_version" label="是否强制">
        <el-switch
          v-model="compulsion"
          inactive-text="不强制"
          active-text="强制"
          :inactive-value="0"
          :active-value="1"
          inactive-color="gray"
          @change="compulsionCheck"
        ></el-switch>
      </el-form-item>
      <el-form-item v-if="dev_ctrl_version&&compulsion" label="强制时间 (分钟)" class="control-slider">
        <el-slider
          v-model="timer"
          :min="1"
          :max="60"
          show-input
        ></el-slider>
      </el-form-item>
      <el-button type="primary" @click="parseDeviceInfo">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import lightListApi from "@/api/light/lightList";
import strategyApi from "@/api/light/strategy";
export default {
  name: "Device",
  props: {
    setData: {
      type: Object,
    },
  },
  data() {
    return {
      manualChange: false,
      lamp_id: this.setData.lamp_id,
      type: this.setData.lamp_type, // 路灯通讯协议 1.NB-IoT、2.Zigbee、3.LoRa、 4.Cat1、5.PLC
      dev_ctrl_version: this.setData.dev_ctrl_version?this.setData.dev_ctrl_version:0, // 新版路灯 0 旧版，1新版
      compulsion: this.setData.compulsion?this.setData.compulsion:0, // 0 不强制  1强制
      timer: this.setData.timer?this.setData.timer:0, // 强制时间 1-60分钟
      name: this.setData.name,
      is_double: this.setData.is_double,
      light: this.setData.light,
      light2: this.setData.light2,
      stg_id: this.setData.stg_id,
      stg_name: this.setData.stg_name,
      ms: this.setData.ms,
      strategyOptions: [],
      updateInfo: {
        lamp_id: this.setData.lamp_id,
        light: 0,
        light2: 0,
        stg_id: 0,
        ms: 0,
        type:1
      },
    };
  },
  methods: {
    getStyList() {
      strategyApi.strategyList({ page: 1, pageSize: 200, type: this.type }).then((res) => {
        if (res.data.code === 1000) {
          this.strategyOptions = res.data.data.list;
        }
      });
    },
    parseDeviceInfo() {
      if(this.dev_ctrl_version&&(this.ms=='0'||this.ms==0)){
        if(this.compulsion==0){
          return this.$message.warning('该路灯为新版路灯，自动模式必须强制设置！');
        }
      }
      this.updateInfo.light = this.light;
      this.updateInfo.light2 = this.light2;
      this.updateInfo.ms = this.ms;
      this.updateInfo.compulsion = this.compulsion;
      this.updateInfo.timer = this.timer;
      if (this.stg_id) {
        this.updateInfo.stg_id = this.stg_id;
        this.updateLightStrategy();
      } else {
        this.$message.error("请选择策略!");
      }
    },
    updateLightStrategy() {
      this.updateInfo.type = this.type
      lightListApi
        .lightStrategysSave(this.updateInfo.lamp_id, this.updateInfo)
        .then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("更改成功！");
            if (this.updateInfo.ms === 1) {
              // 1手动
              this.lightContorl();
            }
            this.$parent.closeSet();
          }else{
            this.$message.error(res.data.message)
          }
        });
    },
    controlCheck(value) {
      if(this.dev_ctrl_version){
        if(value==0){
          this.compulsion = 1
        }else{
          this.compulsion = 0
        }
      }
    },
    compulsionCheck(value) {
      if(this.ms=='0'||this.ms==0){
        if(value==0){
          this.compulsion = 1
          this.$message.warning('该路灯为新版路灯，自动模式必须强制设置！');
        }
      }
      
    },
    lightContorl() {
      let sendData = {
        light: this.updateInfo.light,
        light2: this.updateInfo.light2,
        type: this.type
      };
      lightListApi
        .lightControl(this.updateInfo.lamp_id, sendData)
        .then((res) => {
          if (res.data.code === 1000) {
            this.$message.success(res.data.message);
          }else{
            this.$message.error(res.data.message)
          }
        });
    },
    cancel() {
      this.$parent.closeSet();
    },
  },
  created() {
    this.getStyList();
  },
};
</script>
<style lang='less'>
.control-slider{
  display: flex;
  align-items: center;
  .el-form-item__content{
    width:100%;
    flex: 1;
  }
}
</style>